'use strict';

import React from 'react';
import Public from '@mui/icons-material/Public';
import CenterFocusStrong from '@mui/icons-material/CenterFocusStrong';
import Opacity from '@mui/icons-material/Opacity';
import Biotech from '@mui/icons-material/Biotech';
import Extension from '@mui/icons-material/Extension';

const iconSx = { color: 'inherit', display: 'block' };

export const PRODUCT_FAMILY_ICONS = {
	global: <Public sx={{ ...iconSx, fontSize: 'inherit' }} />,
	targeted: <CenterFocusStrong sx={{ ...iconSx, fontSize: 'inherit' }} />,
	'complex-lipid': <Opacity sx={{ ...iconSx, fontSize: 'inherit' }} />,
	microbiome: <Biotech sx={{ ...iconSx, fontSize: 'inherit' }} />,
	custom: <Extension sx={{ ...iconSx, fontSize: 'inherit' }} />,
};
